/** Days before the first charge. Stripe stores the card; JuDI does not. */
export const TRIAL_DAYS = 30;

/** How long the in-app alert stays up before that first charge. */
export const FIRST_CHARGE_ALERT_MS = 3 * 24 * 60 * 60 * 1000;

export const MONTHLY_AMOUNT_USD = 5;

/** Same page the Android app opens for a Google plan. */
export const PLAY_SUBSCRIPTIONS_URL =
  "https://play.google.com/store/account/subscriptions?sku=judi_monthly&package=com.judi.android";

/** Same page the iPhone app opens for an Apple plan. */
export const APPLE_SUBSCRIPTIONS_URL =
  "https://apps.apple.com/account/subscriptions";

/** A Google plan is changed in Play. Stripe stays on the website plan. */
export function playManageUrl(provider: string | null | undefined): string | null {
  return provider === "google" ? PLAY_SUBSCRIPTIONS_URL : null;
}

/** An Apple plan is changed in Apple subscription settings. */
export function appleManageUrl(
  provider: string | null | undefined,
): string | null {
  return provider === "apple" ? APPLE_SUBSCRIPTIONS_URL : null;
}

/** Play or Apple manage page for a store plan. Stripe stays on the portal. */
export function storeManageUrl(
  provider: string | null | undefined,
): string | null {
  return playManageUrl(provider) ?? appleManageUrl(provider);
}

/**
 * A later start pays from day one. Any earlier subscription row, including
 * one that was canceled during the trial, uses up the single trial.
 */
export function trialPeriodDays(hasPriorSubscription: boolean): number | null {
  return hasPriorSubscription ? null : TRIAL_DAYS;
}

/**
 * The alert is only for the first charge. It stays up for the last 3 days
 * of the trial, and it goes away when the person quits or the trial ends.
 */
export function isFirstChargeAlertDue(
  status: string,
  periodEndIso: string | null | undefined,
  cancelAtPeriodEnd: boolean,
  now: Date,
): boolean {
  if (status !== "trialing" || cancelAtPeriodEnd || !periodEndIso) {
    return false;
  }
  const end = new Date(periodEndIso).getTime();
  if (Number.isNaN(end)) return false;
  const start = end - FIRST_CHARGE_ALERT_MS;
  const time = now.getTime();
  return time >= start && time < end;
}
